<template>
  <div :class="{ 'dd-embedded': embedded }">
    <div v-if="!embedded" class="modal-h dd-modal-h">
      <h3>企业尽调 · {{ applyInfo.companyName || '' }}</h3>
      <span class="card-hd-extra">约 8 分钟</span>
      <button class="modal-x" @click="$emit('close')">✕</button>
    </div>
    <div class="card-bd">
      <!-- 经营场所核实 -->
      <div class="seg-card">
        <div class="seg-title"><span class="sn">1</span>经营场所核实</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>实际经营地址</label>
              <el-input v-model="form.actualAddress" placeholder="输入地址" size="small" />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>场所性质</label>
              <el-select v-model="form.locationType" size="small" style="width:100%">
                <el-option label="自有办公场所" value="自有办公场所" />
                <el-option label="租赁办公场所" value="租赁办公场所" />
                <el-option label="共享办公场所" value="共享办公场所" />
                <el-option label="自有工厂/仓库" value="自有工厂/仓库" />
                <el-option label="租赁工厂/仓库" value="租赁工厂/仓库" />
                <el-option label="无固定场所" value="无固定场所" />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <div class="fld">
          <label class="fld-lbl">场所照片（选填）</label>
          <div class="up-tiles">
            <div
              v-for="(p, i) in sitePhotos"
              :key="i"
              class="up-tile has has-img"
              @click="previewImg = p.preview"
            >
              <img :src="p.preview" alt="场所照片" class="tile-img">
              <button class="tile-del" title="移除" @click.stop="removeSitePhoto(i)">✕</button>
            </div>
            <div v-if="sitePhotos.length < 9" class="up-tile" @click="pickSitePhoto">
              <span style="font-size:20px">+</span>
              <span>补充上传</span>
            </div>
            <input ref="siteFile" type="file" accept="image/*" multiple style="display:none" @change="onSitePhotoChange">
          </div>
        </div>
      </div>

      <!-- 历史发货信息 -->
      <div class="seg-card">
        <div class="seg-title"><span class="sn">2</span>历史发货信息</div>
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>月均发货票数</label>
              <el-input v-model="form.monthlyShipments" type="number" placeholder="如：120" size="small"><template slot="append">票</template></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>月均发货吨位</label>
              <el-input v-model="form.monthlyTonnage" placeholder="如：约 3,600 吨" size="small" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>月均发货金额（万元）</label>
              <el-input v-model="form.monthlyAmount" type="number" placeholder="如：80" size="small"><template slot="append">万</template></el-input>
            </div>
          </el-col>
        </el-row>
        <div class="fld">
          <label class="fld-lbl">历史运输合同<span class="lbl-tip">支持图片 / PDF / Word / Excel 等附件，可多选</span></label>
          <div class="up-tiles">
            <div
              v-for="(f, i) in contractFiles"
              :key="i"
              class="up-tile has"
              :class="{ 'has-img': f.preview }"
              @click="onOpenTile(f)"
            >
              <img v-if="f.preview" :src="f.preview" alt="运输合同" class="tile-img">
              <template v-else>
                <span class="tile-ico">📄</span>
                <span class="tile-name">{{ f.name }}</span>
                <span class="wm">{{ f.meta }}</span>
              </template>
              <button class="tile-del" title="移除" @click.stop="removeFile(contractFiles, i)">✕</button>
            </div>
            <div class="up-tile" @click="pickContractFile">
              <span style="font-size:20px">+</span>
              <span>补充上传</span>
            </div>
            <input ref="contractFile" type="file" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar" multiple style="display:none" @change="onContractFileChange">
          </div>
        </div>
        <div class="fld">
          <label class="fld-lbl">近 3 月历史运单<span class="lbl-tip">支持图片 / PDF / Word / Excel 等附件，可多选</span></label>
          <div class="up-tiles">
            <div
              v-for="(f, i) in waybillFiles"
              :key="i"
              class="up-tile has"
              :class="{ 'has-img': f.preview }"
              @click="onOpenTile(f)"
            >
              <img v-if="f.preview" :src="f.preview" alt="历史运单" class="tile-img">
              <template v-else>
                <span class="tile-ico">📄</span>
                <span class="tile-name">{{ f.name }}</span>
                <span class="wm">{{ f.meta }}</span>
              </template>
              <button class="tile-del" title="移除" @click.stop="removeFile(waybillFiles, i)">✕</button>
            </div>
            <div class="up-tile" @click="pickWaybillFile">
              <span style="font-size:20px">+</span>
              <span>补充上传</span>
            </div>
            <input ref="waybillFile" type="file" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar" multiple style="display:none" @change="onWaybillFileChange">
          </div>
        </div>
      </div>

      <!-- 常发线路与货物 -->
      <div class="seg-card">
        <div class="seg-title"><span class="sn">3</span>常发线路与货物</div>
        <div
          v-for="(r, i) in form.commonRoutes"
          :key="i"
          class="route-line"
        >
          <el-input v-model="r.from" placeholder="始发地" size="small" />
          <span class="arr">→</span>
          <el-input v-model="r.to" placeholder="目的地" size="small" />
          <el-select v-model="r.vehicleType" size="small" placeholder="车型">
            <el-option label="9.6m 高栏" value="9.6m 高栏" />
            <el-option label="13m 半挂" value="13m 半挂" />
            <el-option label="6.8m" value="6.8m" />
          </el-select>
          <el-select v-model="r.frequency" size="small" placeholder="频次">
            <el-option label="每日" value="每日" />
            <el-option label="每周 3-5 次" value="每周 3-5 次" />
            <el-option label="每周 1-2 次" value="每周 1-2 次" />
            <el-option label="不定期" value="不定期" />
          </el-select>
          <el-button
            v-if="form.commonRoutes.length > 1"
            type="text"
            style="color:#ef4444"
            @click="form.commonRoutes.splice(i,1)"
          >删除</el-button>
        </div>
        <el-button size="small" @click="addRoute">+ 添加线路</el-button>
        <el-row :gutter="16" style="margin-top:16px">
          <el-col :span="12">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>常发货物</label>
              <el-input v-model="form.commonCargo" placeholder="如：钢材、建材" size="small" />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>客户所属行业</label>
              <el-select v-model="form.industry" size="small" style="width:100%">
                <el-option label="制造业" value="制造业" />
                <el-option label="贸易/商贸" value="贸易/商贸" />
                <el-option label="物流公司" value="物流公司" />
                <el-option label="建筑工程" value="建筑工程" />
                <el-option label="农业/农副产品" value="农业/农副产品" />
                <el-option label="其他" value="其他" />
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 执行费率与客户需求 -->
      <div class="seg-card">
        <div class="seg-title"><span class="sn">4</span>执行费率与客户需求</div>
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>客户执行费率（%）</label>
              <el-input v-model="form.feeRate" placeholder="如：6.5" size="small" />
              <p class="fld-hint">指导区间 5% - 8%，超出需风控特批</p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>付款周期</label>
              <el-select v-model="form.paymentCycle" size="small" style="width:100%">
                <el-option label="月结 30 天" value="月结 30 天" />
                <el-option label="现结" value="现结" />
                <el-option label="月结 60 天" value="月结 60 天" />
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fld">
              <label class="fld-lbl">是否有常用车队</label>
              <el-select v-model="form.hasOwnFleet" size="small" style="width:100%">
                <el-option label="有，部分运力自带" value="有" />
                <el-option label="无，全部依赖平台" value="无" />
              </el-select>
            </div>
          </el-col>
        </el-row>

        <div class="fld" style="margin-top:12px">
          <label class="fld-lbl">客户痛点（多选）</label>
          <div class="chip-group">
            <span
              v-for="p in painOptions"
              :key="p"
              class="chip"
              :class="{ on: painSelected[p] }"
              @click="$set(painSelected, p, !painSelected[p])"
            >{{ p }}</span>
          </div>
        </div>
        <div class="fld" style="margin-top:12px">
          <label class="fld-lbl">客户需求（多选，转化为增值服务推荐）</label>
          <div class="chip-group">
            <span
              v-for="n in needOptions"
              :key="n"
              class="chip"
              :class="{ on: needSelected[n] }"
              @click="$set(needSelected, n, !needSelected[n])"
            >{{ n }}</span>
          </div>
        </div>
        <div class="fld" style="margin-top:12px">
          <label class="fld-lbl">其他说明</label>
          <el-input v-model="form.serviceRemark" type="textarea" :rows="2" placeholder="注册时填写的其他说明" size="small" />
        </div>

        <div class="fld" style="margin-top:16px">
          <label class="fld-lbl"><span class="req">*</span>尽调结论</label>
          <el-input
            v-model="form.ddConclusion"
            type="textarea"
            :rows="3"
            placeholder="综合评价：经营场所真实性、历史发货规模、运输需求合理性等"
            size="small"
          />
        </div>
      </div>

      <div v-if="!embedded" class="dd-ft">
        <span class="dd-ft-note">提交后您的工作即完成，审核结果将通过站内消息通知您</span>
        <div class="dd-ft-acts">
          <el-button size="small" :loading="saving" @click="onSaveDraft">暂存草稿</el-button>
          <el-button size="small" type="primary" :loading="submitting" @click="onSubmit">提交尽调，进入平台审核</el-button>
        </div>
      </div>
    </div>

    <div v-if="previewImg" class="img-preview" @click.self="previewImg = ''">
      <button class="img-preview-x" @click="previewImg = ''">✕</button>
      <img :src="previewImg" :style="previewImgStyle" alt="预览">
      <div class="img-preview-toolbar">
        <button class="img-preview-tool" title="缩小" @click="previewZoomOut"><i class="el-icon-zoom-out" /></button>
        <button class="img-preview-tool" title="放大" @click="previewZoomIn"><i class="el-icon-zoom-in" /></button>
        <button class="img-preview-tool" title="自适应" @click="previewFit"><i class="el-icon-full-screen" /></button>
        <button class="img-preview-tool" title="向左旋转" @click="previewRotateLeft"><i class="el-icon-refresh-left" /></button>
        <button class="img-preview-tool" title="向右旋转" @click="previewRotateRight"><i class="el-icon-refresh-right" /></button>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeUploadUrl } from "@/utils/uploadUrl";
import { saveDueDiligence } from "@/api/shipmentApply";
import request from "@/utils/request";

const painOptions = ["时效不稳定", "价格不透明", "回单返回慢", "对账繁琐", "垫资压力大", "旺季叫车难"];
// 与企业邀请注册第三步“服务需求”保持一致。
const needOptions = [
  "运费垫付", "货运保险", "账期支持", "回单电子化",
  "油卡 / ETC", "冷链运力", "大件运输", "专属客服"
];
const legacyNeedMap = {
  货物运输保险: "货运保险",
  "运费垫付/账期支持": ["运费垫付", "账期支持"]
};
const FILE_IMG_RE = /\.(png|jpe?g|gif|webp|bmp)$/i;

function normalizeLocationType(value) {
  const legacyMap = { 自有产权: "自有办公场所", 租赁: "租赁办公场所", 共享办公: "共享办公场所" };
  return legacyMap[value] || value || "自有办公场所";
}

function fileNameOf(url, fallback) {
  try { return decodeURIComponent(String(url).split("/").pop() || "") || fallback; } catch (e) { return fallback; }
}

function toFileItems(str, fallbackName) {
  return String(str || "")
    .split(",")
    .filter(Boolean)
    .map(u => ({
      name: fileNameOf(u, fallbackName),
      meta: "",
      url: u,
      preview: FILE_IMG_RE.test(u) ? u : ""
    }));
}

export default {
  name: "DdForm",
  props: {
    applyCode: { type: String, default: "" },
    applyInfo: { type: Object, default: () => ({}) },
    embedded: { type: Boolean, default: false }
  },
  data() {
    const ddData = (this.applyInfo && this.applyInfo.ddData) || {};
    let routes = [{ from: "", to: "", vehicleType: "9.6m 高栏", frequency: "每周 3-5 次" }];
    if (ddData.commonRoutes) {
      try { routes = JSON.parse(ddData.commonRoutes); } catch (e) { /* keep default */ }
    }
    const painStr = ddData.customerPainPoints || "";
    const needStr = ddData.customerNeeds || "";
    const painSelected = {};
    painOptions.forEach(p => { painSelected[p] = painStr.includes(p); });
    const needSelected = {};
    needOptions.forEach(n => { needSelected[n] = needStr.includes(n); });
    Object.keys(legacyNeedMap).forEach(oldName => {
      if (!needStr.includes(oldName)) return;
      const mapped = legacyNeedMap[oldName];
      (Array.isArray(mapped) ? mapped : [mapped]).forEach(name => { needSelected[name] = true; });
    });
    return {
      saving: false,
      submitting: false,
      form: {
        actualAddress: ddData.actualAddress || (this.applyInfo && this.applyInfo.officeAddress) || "",
        locationType: normalizeLocationType(ddData.locationType || (this.applyInfo && this.applyInfo.officeType)),
        sitePhotos: ddData.sitePhotos || "",
        monthlyShipments: ddData.monthlyShipments || "",
        monthlyTonnage: ddData.monthlyTonnage || "",
        monthlyAmount: ddData.monthlyAmount || "",
        commonRoutes: routes,
        commonCargo: ddData.commonCargo || "",
        industry: ddData.industry || "制造业",
        feeRate: ddData.feeRate || "",
        paymentCycle: ddData.paymentCycle || "月结 30 天",
        hasOwnFleet: ddData.hasOwnFleet || "无",
        serviceRemark: ddData.serviceRemark || (this.applyInfo && this.applyInfo.serviceRemark) || "",
        ddConclusion: ddData.ddConclusion || ""
      },
      painOptions, needOptions,
      painSelected,
      needSelected,
      sitePhotos: ddData.sitePhotos
        ? String(ddData.sitePhotos).split(",").filter(Boolean).map(u => ({ name: "已上传", preview: u }))
        : [],
      contractFiles: toFileItems(ddData.supplementaryMaterials2Img || (this.applyInfo && this.applyInfo.supplementaryMaterials2Img) || "", "历史运输合同"),
      waybillFiles: toFileItems(ddData.supplementaryMaterials3Img || (this.applyInfo && this.applyInfo.supplementaryMaterials3Img) || "", "近 3 月历史运单"),
      previewImg: "",
      previewRotate: 0,
      previewScale: 1
    };
  },
  computed: {
    previewImgStyle() {
      const deg = ((this.previewRotate % 360) + 360) % 360;
      const sideways = deg === 90 || deg === 270;
      return {
        transform: `rotate(${this.previewRotate}deg) scale(${this.previewScale})`,
        maxWidth: sideways ? "88vh" : "90%",
        maxHeight: sideways ? "90%" : "88%"
      };
    }
  },
  watch: {
    previewImg() {
      this.previewRotate = 0;
      this.previewScale = 1;
    }
  },
  methods: {
    previewZoomIn() {
      this.previewScale = Math.min(3, +(this.previewScale + 0.2).toFixed(2));
    },
    previewZoomOut() {
      this.previewScale = Math.max(0.5, +(this.previewScale - 0.2).toFixed(2));
    },
    previewFit() {
      this.previewRotate = 0;
      this.previewScale = 1;
    },
    previewRotateLeft() {
      this.previewRotate -= 90;
    },
    previewRotateRight() {
      this.previewRotate += 90;
    },
    addRoute() {
      if (this.form.commonRoutes.length >= 10) return;
      this.form.commonRoutes.push({ from: "", to: "", vehicleType: "9.6m 高栏", frequency: "每周 3-5 次" });
    },
    pickSitePhoto() {
      this.$refs.siteFile.value = "";
      this.$refs.siteFile.click();
    },
    async onSitePhotoChange(e) {
      const files = e.target.files;
      if (!files || !files.length) return;
      const list = Array.from(files);
      for (const f of list) {
        if (this.sitePhotos.length >= 9) break;
        try {
          const url = await this.uploadFile(f);
          this.sitePhotos.push({ name: f.name, preview: url });
        } catch (err) { /* 单张失败跳过 */ }
      }
      this.form.sitePhotos = this.sitePhotos.map(x => x.preview).join(",");
      this.$refs.siteFile.value = "";
    },
    pickContractFile() {
      this.$refs.contractFile.value = "";
      this.$refs.contractFile.click();
    },
    pickWaybillFile() {
      this.$refs.waybillFile.value = "";
      this.$refs.waybillFile.click();
    },
    async onContractFileChange(e) {
      const files = e.target.files;
      if (!files || !files.length) return;
      const list = Array.from(files);
      for (const f of list) {
        if (this.contractFiles.length >= 4) { this.$message.warning("历史运输合同最多上传 4 个附件"); break; }
        try {
          const url = await this.uploadFile(f);
          const isImg = /image\//.test(f.type);
          this.contractFiles.push({ name: f.name, meta: (f.size / 1024).toFixed(1) + " KB", url, preview: isImg ? url : "" });
        } catch (err) { /* 单个失败跳过 */ }
      }
      this.$refs.contractFile.value = "";
    },
    async onWaybillFileChange(e) {
      const files = e.target.files;
      if (!files || !files.length) return;
      const list = Array.from(files);
      for (const f of list) {
        if (this.waybillFiles.length >= 4) { this.$message.warning("近 3 月历史运单最多上传 4 个附件"); break; }
        try {
          const url = await this.uploadFile(f);
          const isImg = /image\//.test(f.type);
          this.waybillFiles.push({ name: f.name, meta: (f.size / 1024).toFixed(1) + " KB", url, preview: isImg ? url : "" });
        } catch (err) { /* 单个失败跳过 */ }
      }
      this.$refs.waybillFile.value = "";
    },
    onOpenTile(f) {
      if (f.preview) { this.previewImg = f.preview; return; }
      if (f.url) window.open(f.url, "_blank");
    },
    removeFile(list, i) { list.splice(i, 1); },
    removeSitePhoto(i) {
      this.sitePhotos.splice(i, 1);
      this.form.sitePhotos = this.sitePhotos.map(x => x.preview).join(",");
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      return request({
        url: "/ntocc-tps-api/fileUpload",
        method: "post",
        data: formData
      }).then(res => {
        if (res && res.data) return normalizeUploadUrl(res.data);
        throw new Error("上传失败");
      });
    },
    buildPayload(action) {
      return {
        applyCode: this.applyCode,
        action,
        ...this.form,
        commonRoutes: JSON.stringify(this.form.commonRoutes),
        bankLicenseImg: (this.applyInfo && this.applyInfo.bankLicenseImg) || "",
        supplementaryMaterials2Img: this.contractFiles.map(f => f.url || f.preview || "").filter(Boolean).join(","),
        supplementaryMaterials3Img: this.waybillFiles.map(f => f.url || f.preview || "").filter(Boolean).join(","),
        customerPainPoints: Object.keys(this.painSelected).filter(k => this.painSelected[k]).join(","),
        customerNeeds: Object.keys(this.needSelected).filter(k => this.needSelected[k]).join(",")
      };
    },
    async onSaveDraft() {
      this.saving = true;
      try {
        await saveDueDiligence(this.buildPayload("DRAFT"));
        this.$message.success("草稿已保存");
      } catch (e) {
        this.$message.error((e && e.message) || "保存失败");
      } finally {
        this.saving = false;
      }
    },
    async onSubmit() {
      if (!this.form.actualAddress) { this.$message.warning("请填写实际经营地址"); return; }
      if (!this.form.monthlyShipments) { this.$message.warning("请填写月均发货票数"); return; }
      if (!this.form.feeRate) { this.$message.warning("请填写执行费率"); return; }
      if (!this.form.ddConclusion) { this.$message.warning("请填写尽调结论"); return; }
      this.submitting = true;
      try {
        await saveDueDiligence(this.buildPayload("SUBMIT"));
        this.$emit("submitted");
      } catch (e) {
        this.$message.error((e && e.message) || "提交失败");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-h.dd-modal-h {
  display: flex; align-items: center; gap: 12px;
  padding: 16px 20px; border-bottom: 1px solid var(--line2);
  font-size: 15px; font-weight: 700; color: var(--ink);
  flex-wrap: wrap;
  h3 { font-size: 15px; font-weight: 700; margin: 0; display: flex; align-items: center; gap: 8px;
    &::before { content: ""; width: 3px; height: 13px; border-radius: 2px; background: var(--grad); }
  }
  .card-hd-extra { font-size: 12px; color: var(--ink3); flex: 1; }
}
.card-bd { padding: 20px; }
.dd-embedded .card-bd { padding: 0; }
.modal-x {
  width: 30px; height: 30px; border-radius: 9px; color: var(--ink4);
  font-size: 14px; border: none; background: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: var(--line2); color: var(--ink); }
}

  .seg-card {
    border: 1px solid var(--line);
    border-radius: var(--r);
    padding: 16px 18px;
    margin-bottom: 14px;
    background: var(--surface);
  }
  .seg-title {
    font-size: 13.5px; font-weight: 700; color: var(--ink2);
    display: flex; align-items: center; gap: 8px; margin-bottom: 14px;
    .sn {
      width: 22px; height: 22px; border-radius: 50%; background: var(--grad);
      color: #fff; display: flex; align-items: center; justify-content: center;
      font-size: 11px; font-weight: 700; flex-shrink: 0;
    }
  }

  .fld { margin-bottom: 12px; }
  .fld-lbl { font-size: 12.5px; font-weight: 500; color: var(--ink2); margin-bottom: 7px; display: flex; align-items: center; gap: 4px;
    .req { color: var(--err); }
  }
  .lbl-tip { font-size: 11px; color: var(--ink4); font-weight: 400; margin-left: 6px; }
  .fld-hint { font-size: 11.5px; color: var(--ink4); margin-top: 4px; }

  .up-tiles { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 12px; }
  .up-tile {
    border: 1.5px dashed #D9DEE6; border-radius: 11px; min-height: 96px;
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
    color: var(--ink4); font-size: 12px; transition: all 0.15s;
    background: #FAFBFC; cursor: pointer; text-align: center; padding: 6px; position: relative;
  }
  .up-tile:hover { border-color: var(--b1); background: rgba(66,109,240,0.03); color: var(--b1); }
  .up-tile.has { border-style: solid; border-color: #BFE3D6; background: #FBFFFD; color: var(--ink2); }
  .up-tile .wm { font-size: 10px; color: var(--success); line-height: 1.4; }
  .up-tile.has-img { padding: 0; overflow: hidden; min-height: 96px; }
  .up-tile .tile-img { width: 100%; height: 96px; object-fit: cover; display: block; }
  .up-tile .tile-cnt { position: absolute; right: 6px; top: 6px; font-size: 10px; background: rgba(0,0,0,0.55); color: #fff; border-radius: 5px; padding: 1px 6px; }
  .up-tile.has-img { position: relative; }
  .up-tile .tile-name { font-size: 11px; padding: 5px 8px; text-align: center; color: var(--ink2); word-break: break-all; }
  .tile-ico { font-size: 22px; line-height: 1; }
  .tile-del { position: absolute; top: 4px; right: 4px; width: 18px; height: 18px; border-radius: 50%; border: none; background: rgba(15,23,42,0.5); color: #fff; font-size: 10px; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; padding: 0; }
  .tile-del:hover { background: var(--err); }

  .img-preview { position: fixed; inset: 0; z-index: 3000; background: rgba(10,14,20,0.85); display: flex; align-items: center; justify-content: center; padding: 40px; overflow: hidden; }
  .img-preview img { max-width: 90%; max-height: 88%; object-fit: contain; border-radius: 8px; box-shadow: 0 16px 60px rgba(0,0,0,0.5); background: #fff; }
  .img-preview-x { position: fixed; top: 20px; right: 24px; width: 36px; height: 36px; border-radius: 50%; border: none; background: rgba(255,255,255,0.15); color: #fff; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
  .img-preview-x:hover { background: rgba(255,255,255,0.3); }
  .img-preview-toolbar { position: fixed; left: 50%; bottom: 28px; transform: translateX(-50%); display: flex; align-items: center; gap: 6px; padding: 8px 14px; border-radius: 999px; background: rgba(60,64,72,0.72); }
  .img-preview-tool { width: 40px; height: 40px; border: none; background: transparent; color: #fff; font-size: 20px; cursor: pointer; display: flex; align-items: center; justify-content: center; border-radius: 50%; }
  .img-preview-tool:hover { background: rgba(255,255,255,0.18); }

  .route-line { display: grid; grid-template-columns: 1fr 24px 1fr 130px 130px auto; gap: 8px; align-items: center; margin-bottom: 8px; }
  .route-line .arr { color: var(--b1); text-align: center; font-weight: 700; }
  .route-line ::v-deep .el-input__inner { font-size: 13.5px; }
  @media (max-width: 720px) { .route-line { grid-template-columns: 1fr 24px 1fr; } }

  .chip-group { display: flex; flex-wrap: wrap; gap: 6px; }
  .chip {
    padding: 7px 14px; border-radius: 999px; border: 1px solid var(--line);
    font-size: 12.5px; color: var(--ink2); cursor: pointer; user-select: none;
    transition: all 0.15s; background: var(--surface);
    &:hover { border-color: var(--b1); color: var(--b1); }
    &.on { border-color: var(--b1); color: var(--b1); background: rgba(66,109,240,0.05); font-weight: 600; }
  }

  .dd-ft {
    display: flex; justify-content: space-between; align-items: center; gap: 12px;
    padding-top: 16px; border-top: 1px solid var(--line); flex-wrap: wrap;
    .dd-ft-note { font-size: 12px; color: var(--ink4); }
    .dd-ft-acts { display: flex; gap: 8px; }
  }
</style>
